import React, { useState } from 'react';
import { useData } from "../../../components/context/DataContext";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, EffectFlip, EffectFade, Pagination, Scrollbar, A11y } from 'swiper/modules';
import { useModuleIndex, useScreenIndex, useScreenIndexUpdate } from "../../../components/context/ModuleContext";
import { useScreenType, useScreenTypeUpdate, useSwipers, useSwipersUpdate } from "../../../components/context/MixContext";
import { useScreenShowUpdate } from "../../../components/context/ScreenContext";

import { Virtual } from 'swiper/modules';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/virtual';
import 'swiper/css/effect-flip';
import 'swiper/css/effect-fade';

import '../Slides.css'

import AbdomenSlide00 from "../../../layout/Slides/Abdomen/Slide00";
import AbdomenSlide01 from "../../../layout/Slides/Abdomen/Slide01";
import AbdomenSlide02 from "../../../layout/Slides/Abdomen/Slide02";
import AbdomenSlide03 from "../../../layout/Slides/Abdomen/Slide03";
import AbdomenSlide04 from "../../../layout/Slides/Abdomen/Slide04";
import AbdomenSlide05 from "../../../layout/Slides/Abdomen/Slide05";

const AbdomenSlideHolder = () => {

    // Screen show
    const setScreenShow = useScreenShowUpdate();

    // data
    const json = useData();

    // module index
    const getModuleIndex = useModuleIndex();
    const setModuleIndex = useScreenIndexUpdate();

    // currentIndex
    let [currentIndex, setCurrentIndex] = useState(0)

    // screen type
    const getScreenType = useScreenType();
    const setScreenType = useScreenTypeUpdate();

    // screen index
    const getScreenIndex = useScreenIndex();
    const setScreenIndex = useScreenIndexUpdate();

    // swipers
    const getSwipers = useSwipers();
    const setSwipers = useSwipersUpdate();

    const prevSlidePlease = (_swipe) => {
        const idx = currentIndex;
        setCurrentIndex(idx-1);
        checkNav(_swipe, false, idx-1);
    }
    const nextSlidePlease = (_swipe) => {
        const idx = currentIndex;
        setCurrentIndex(idx+1);
        checkNav(_swipe, true, idx+1);
    }

    const checkNav = (_swiper, _next, _idx) => {
        if ( _next ) {
            if ( currentIndex === _swiper.slides.length-1 ) {
                setScreenShow(true);
            } else {
                _swiper.slideNext();
                const info = document.getElementById("slide-data");
                info.innerHTML = json && json.screen[getModuleIndex].data[_idx][0].txt;
                setScreenIndex(_idx);
            }
        } else {
            if ( currentIndex === 0 ) {
                setScreenShow(true);
            } else {
                _swiper.slidePrev();
                const info = document.getElementById("slide-data");
                info.innerHTML = json && json.screen[getModuleIndex].data[_idx][0].txt;
                setScreenIndex(_idx);
            }
        }
    }

    return (
        <Swiper
            observer={true}
            observeParents={true}
            autoHeight= {true}
            modules={[Navigation, EffectFade, EffectFlip, A11y, Virtual]}
            spaceBetween={2}
            slidesPerView={1}
            noSwiping={true}  
            noSwipingClass='noswiper'
            centeredSlides
            onSlideChange={(swiper) => {
                //
            }}
            onAfterInit={(swiper) => {
                swiper.slideTo(getScreenIndex, .2);
                setCurrentIndex(getScreenIndex)
                const info = document.getElementById("slide-data");
                info.innerHTML = json && json.screen[getModuleIndex].data[getScreenIndex][0].txt;
            }}
            onBeforeSlideChangeStart={(swiper) => {
                // 
            }}
            onSlideChangeTransitionEnd={(swiper) => {
                
            }}
            onReachEnd={(swiper) => {
                // console.log("reach end");
            }}
        >

            <SwiperSlide className="noswiper" key={0} virtualIndex={0}>
                <AbdomenSlide00 slideprevplease={prevSlidePlease} slidenextplease={nextSlidePlease} mod="3" screen="0" data={json && json.screen[getModuleIndex].data[0][0]} />
            </SwiperSlide>
            <SwiperSlide className="noswiper" key={1} virtualIndex={1}>
                <AbdomenSlide01 slideprevplease={prevSlidePlease} slidenextplease={nextSlidePlease} mod="3" screen="1" data={json && json.screen[getModuleIndex].data[1][0]} />
            </SwiperSlide>
            <SwiperSlide className="noswiper" key={2} virtualIndex={2}>
                <AbdomenSlide02 slideprevplease={prevSlidePlease} slidenextplease={nextSlidePlease} mod="3" screen="2" data={json && json.screen[getModuleIndex].data[2][0]} />
            </SwiperSlide>
            <SwiperSlide className="noswiper" key={3} virtualIndex={3}>
                <AbdomenSlide03 slideprevplease={prevSlidePlease} slidenextplease={nextSlidePlease} mod="3" screen="3" data={json && json.screen[getModuleIndex].data[3][0]} />
            </SwiperSlide>
            <SwiperSlide className="noswiper" key={4} virtualIndex={4}>
                <AbdomenSlide04 slideprevplease={prevSlidePlease} slidenextplease={nextSlidePlease} mod="3" screen="4" data={json && json.screen[getModuleIndex].data[4][0]} />
            </SwiperSlide>
            <SwiperSlide className="noswiper" key={5} virtualIndex={5}>
                <AbdomenSlide05 slideprevplease={prevSlidePlease} slidenextplease={nextSlidePlease} mod="3" screen="5" data={json && json.screen[getModuleIndex].data[5][0]} />
            </SwiperSlide>
        </Swiper>
    );
};

export default AbdomenSlideHolder;